import type { PluginKey } from '@sportninja/common/features/account/apiAccess'

/**
 * The key the builder uses: the one the admin chose while it still exists,
 * else the first live key, else the first key. `null` when there are none.
 */
export const selectPluginKey = (
  pluginKeys: PluginKey[],
  chosenKeyId: string | null
): PluginKey | null =>
  pluginKeys.find(({ id }) => id === chosenKeyId) ??
  pluginKeys.find(({ environment }) => environment === 'live') ??
  pluginKeys[0] ??
  null
